export const linking = {
  config: {
    screens: {
      //marketing
      marketing: "",
      plans: "/plans",
      business: "/business",
      mobile: "/mobile",
      hospitality: "/hospitality",
      gov: "/gov",
      impactstudy: "/impactstudy/:type",
      tos: "/tos",
      patent: "/patent",
      privacy: "/privacy",
      aboutus: "/aboutus",
      devops: "/devops",
      e911: "/e911",

      //auth
      auth: "/auth",
      authcode: "/authcode/:token",

      //dashboard
      dashboard: "/dashboard",

      //admin
      admin: {
        path: "/admin",
        screens: {
          admin: "/:token",
          did: "/:token/did/:token2",
        },
      },

      //wholesale
      wholesale: {
        path: "/wholesale",
        screens: {
          wholesale: "/:deviceid",
          did: "/:deviceid/did",
          ip: "/:deviceid/ip",
        },
      },

      notfound: "*",
    },
  },
};

const routes = {
  //marketing
  marketing: "marketing",
  plans: "plans",
  business: "business",
  mobile: "mobile",
  hospitality: "hospitality",
  gov: "gov",
  impactstudy: "impactstudy",
  tos: "tos",
  patent: "patent",
  privacy: "privacy",
  aboutus: "aboutus",
  devops: "devops",
  e911: "e911",

  //auth
  auth: "auth",
  authcode: "authcode",

  //dashboard
  dashboard: "dashboard",

  //admin
  admin: "admin",

  //wholesale
  wholesale: "wholesale",
  ip: "ip",

  //common
  did: "did",

  notfound: "notfound",
};

export default routes;
